"use client";

import { useSyncExternalStore } from "react";
import { Button, Text } from "@dionatanbig2be/big2be-ui";
import { readConsent, saveConsent, type ConsentChoice } from "../lib/consent";

// O cookie não avisa quando muda: quem grava (este banner) notifica.
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

/** `true` = ainda não escolheu. No servidor é sempre `false`: o HTML vai sem o aviso. */
const isPending = () => readConsent(document.cookie) === null;
const isPendingOnServer = () => false;

/**
 * Aviso de cookies. Só é montado quando o tenant tem alguma tag ligada — loja
 * sem medição não pede consentimento para nada. Aparece até o cliente
 * escolher; a escolha vale por um ano (ver lib/consent). Lido só no browser:
 * o HTML é igual para todos (cache de borda).
 */
export function ConsentBanner() {
    const pending = useSyncExternalStore(subscribe, isPending, isPendingOnServer);

    if (!pending) return null;

    const choose = (choice: ConsentChoice) => {
        saveConsent(choice);
        listeners.forEach((listener) => listener());
    };

    return (
        <div
            role="dialog"
            aria-modal="false"
            aria-labelledby="consent-banner-title"
            className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-xl rounded-box border border-base-300 bg-base-100 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] text-base-content shadow-xl md:inset-x-auto md:left-4"
        >
            <Text id="consent-banner-title" weight="semibold" className="block leading-snug">
                Cookies e privacidade
            </Text>
            <Text className="mt-1 block text-sm text-base-content/70">
                Usamos cookies para medir o uso da loja e mostrar anúncios mais relevantes. Você pode
                aceitar ou recusar; os cookies essenciais para a compra funcionam de qualquer jeito.
            </Text>
            <div className="mt-3 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                <Button type="button" variant="ghost" size="sm" onClick={() => choose("denied")}>
                    Recusar
                </Button>
                <Button type="button" tone="primary" size="sm" onClick={() => choose("granted")}>
                    Aceitar cookies
                </Button>
            </div>
        </div>
    );
}
